import { Method } from 'axios';
import { EventsNames } from '../../enums/Events';

export interface Headers {
  [Name: string]: string;
}

export enum OnEvent {
  Failure,
  Success,
  All,
}

export enum TrackCategory {
  Action = 'action',
  Error = 'error',
  View = 'view',
  Sample = 'sample',
}

// TODO Delete ITrack and use Track
export interface ITrack {
  eventName: string;
  props: any;
  onEvent?: OnEvent;
  category?: TrackCategory;
}

export interface Request {
  method?: Method;
  headers?: Headers;
  data?: any;
  url: string;
  trackingInfo?: Track;
  params?: object;
  retries?: number;
}

export interface Info {
  type: TrackCategory;
}

// Info extending should be removed in the future SBT-20130
export interface DataDogInfo extends Info {
  errorInfo?: {
    code?: string;
  };
}

export interface Track {
  eventName: EventsNames | string;
  props?: any;
  datadogInfo?: DataDogInfo;
  type?: TrackCategory;
}

export interface TrackCallback {
  (track: Track): void;
}

export interface Init {
  baseUrl: string;
  headers?: Headers;
  track: TrackCallback;
  token?: string;
  addNetworkErrorLogs?: ({ error }: { error: NetworkServiceError }) => void;
}

export interface ExtraEventsData {
  url: string;
  method: Method;
  params: any;
  baseURL: string;
  headers: any;
  timeout: number;
  responseType: string;
}

export interface NetworkServiceError extends Error, ExtraEventsData {
  eventName: string;
  responseData: any;
  code: string;
  status?: string;
}
